<template>
  <PhTrash :size="20" />
</template>

<script setup>
import { PhTrash } from "@phosphor-icons/vue";
</script>
